import {Message} from '../../utils/JobsPostAd/message';
import {POST_AD_FIELDS} from '../../utils/JobsPostAd';


export const defaultState = {
  step: 0,

  isFlexiUser: false,

  candidateMobile: {
    value: '',
    message: (new Message(1, 0, '', { field: 'candidateMobile' })).get(),
    options: [],
    label: 'Mobile Number*',
    disabled: false
  },
  candidateOtp: {
    value: '',
    message: (new Message(1, 0, '', { field: 'candidateOtp' })).get(),
    options: [],
    label: 'OTP'
  },
  name: {
    value: '',
    show: true,
    disabled: false,
    message: (new Message(1,0, '', { field: 'name' })).get(),
    label: 'Name'
  },
  email: {
    value: '',
    show: true,
    disabled: false,
    message: (new Message(1,0, '', { field: 'email' })).get(),
    label: 'Email'
  },
  city: {
    options: [],
    value: '',
    id: '',
    apiUrl: '/jobs/jobsAjax/getAllCities',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.CITY })).get(),
  },
  locality: {
    apiUrl: '/jobs/jobsAjax/localitySearch?cityName=',
    value: [],
    disabled: true,
    show: true,
    maxLimit: 5,
    fullCity : {
      display: '',
      show: false
    },
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.LOCALITY })).get(),
  },
  role: {
    options: [],
    // id: '',
    valueObject: {},
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.ROLE })).get(),
    others: '',
    disabled: false
  },
  subRole: {
    subList: [],
    show: true,
    value: [],
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.SUB_ROLE })).get(),
    others: ''
  },
  moveToRmt: {
    checked: false
  },
  others: {
    formType: 'FLEXI_CANDIDATE_STEP_0',
    message: '',
    customErrorField: ''
  },

  otpObject: {
    verifyMobile: null,
    isMobileAvailable: 0,
    fromSource: 'FlexiCandidate'
  },

  context: {
    profileType: 'NEW',
    rmtOptions: {}
  },

  showSuccessPopup: false,

  candidateProfileId: null,
  candidateUser: null,
  candidateProfile: {},
  candidateProfileRsa: {},
  candidateProfiles: [],
  candidateQuestions: [],
  candidateProfileStep: 0,
  candidateProfileRequest: {
    'sortType': 3,
    'filters': {
      'profileIdList': [],
      'roleIdList': [],
      'userIdList': []
    },
    'count': 20,
    'offset': 0
  },
  candidateProfileQuestions: [],
  flexiContextUpdatedInStore: false,
  flexiUserDetailsUpdatedInStore: false,

  recruiterProfileStep: 0,
  recruiterFolder: {
    show: true,
    id: '',
    value: '',
    message: (new Message(1, 0, '', { field: 'recruiterFolder' })).get(),
    others: ''
  },
  recruiterStatus: {
    show: true,
    value: '',
    message: (new Message(1, 0, '', { field: 'recruiterStatus' })).get(),
    others: ''
  },
  recruiterType: {
    show: true,
    value: '',
    message: (new Message(1, 0, '', { field: 'recruiterType' })).get(),
    others: ''
  },
  recruiterComment: {
    value: '',
    show: true,
    disabled: false,
    message: (new Message(1,0, '', { field: 'recruiterComment' })).get(),
    others: ''
  },
  recruiterDateOfAction: {
    value: '',
    show: true,
    disabled: false,
    message: (new Message(1,0, '', { field: 'recruiterDateOfAction' })).get(),
    others: ''
  },
  recruiterTimeOfAction: {
    value: '',
    show: true,
    disabled: false,
    message: (new Message(1,0, '', { field: 'recruiterTimeOfAction' })).get(),
    others: ''
  },
};

const flexiCandidateReducer = (state = defaultState, actions) => {
  switch (actions.type) {
    case 'UPDATE_FLEXI_CANDIDATE_STATE': {
      state = Object.assign({}, state, actions.payload);
      break;
    }
  }

  return state;
};

export default flexiCandidateReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/FlexiCandidateReducer/index.js